export default "__VITE_ASSET__0ab81d66__"